// Pure local-clock proposals; provider evidence remains unchanged.
export function seasonClock(value){
 if(typeof value!=='string')return null;
 const text=value.trim().toLowerCase().replaceAll('.','');
 const m=text.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*([ap]m)?$/);if(!m)return null;
 let h=Number(m[1]);const min=Number(m[2]),sec=Number(m[3]||0);if(min>59||sec>59)return null;
 if(m[4]){if(h<1||h>12)return null;h=h%12+(m[4]==='pm'?12:0);}else if(h>23)return null;
 return `${String(h).padStart(2,'0')}:${String(min).padStart(2,'0')}:${String(sec).padStart(2,'0')}`;
}
export function seasonStartTime(match){
 if(match.time)return {time:seasonClock(match.time),source:'provider_match_time'};
 const values=(Array.isArray(match.lineStartTimes)?match.lineStartTimes:[]).map(seasonClock);
 if(!values.length)return {time:null,source:'missing'};
 if(values.some(v=>!v)||new Set(values).size!==1)return {time:null,source:'ambiguous_line_times'};
 return {time:values[0],source:'consistent_provider_line_times'};
}
export function seasonTimeFill(match,saved,leadMinutes){
 const proposal=seasonStartTime(match),patch={};
 if(!saved.match_time&&proposal.time)patch.match_time=proposal.time;
 const effective=seasonClock(saved.match_time||proposal.time);
 if(!saved.warmup_time&&effective&&Number.isInteger(leadMinutes)&&leadMinutes>=0&&leadMinutes<=120){
  const [h,m,s]=effective.split(':').map(Number),seconds=((h*3600+m*60+s-leadMinutes*60)%86400+86400)%86400;
  patch.warmup_time=`${String(Math.floor(seconds/3600)).padStart(2,'0')}:${String(Math.floor(seconds/60)%60).padStart(2,'0')}:${String(seconds%60).padStart(2,'0')}`;
 }
 return {patch,source:saved.match_time?'saved_match_time':proposal.source};
}
